const pageNameKey = "questionMarkPopover";

export const questionMarkPopoverEn = {
  [pageNameKey]: {
    explanation: "{possible} <b>{machine}</b> {status}",
    possible: "Possible",
    machine: "Machine",
    status: "Status",
    disconnectedLabel: "Disconnected",
    disconnectedDescription:
      "Connection to the machine (e.g. OPC UA server) has not been established.",
    connectedLabel: "Connected",
    connectedDescription:
      "Connection to the machine (e.g. OPC UA server) has been established.",
  },
};

export const questionMarkPopoverPtBr = {
  [pageNameKey]: {
    explanation: "{possible} <b>{machine}</b> {status}",
    possible: "Possível",
    machine: "Máquina",
    status: "Status",
    disconnectedLabel: "Desconectado",
    disconnectedDescription:
      "A conexão com a máquina (por exemplo, servidor OPC UA) não foi estabelecida.",
    connectedLabel: "Conectado",
    connectedDescription:
      "A conexão com a máquina (por exemplo, servidor OPC UA) foi estabelecida.",
  },
};

export const questionMarkPopoverDe = {
  [pageNameKey]: {
    explanation: "{possible} <b>{machine}{status}</b>",
    possible: "Möglicher",
    machine: "Maschine",
    status: "status",
    disconnectedLabel: "Getrennt",
    disconnectedDescription:
      "Die Verbindung zur Maschine (z.B. OPC UA-Server) wurde nicht hergestellt.",
    connectedLabel: "Verbunden",
    connectedDescription:
      "Die Verbindung zur Maschine (z.B. OPC UA-Server) wurde hergestellt.",
  },
};

export const questionMarkPopoverZhHans = {
  [pageNameKey]: {
    explanation: "{possible} <b>{machine}{status}</b>",
    possible: "可能的",
    machine: "机器",
    status: "状态",
    disconnectedLabel: "已断开",
    disconnectedDescription: "尚未与机器（例如 OPC UA 服务器）建立连接。",
    connectedLabel: "已连接",
    connectedDescription: "已与机器（例如 OPC UA 服务器）建立连接。",
  },
};

export const questionMarkPopoverIt = {
  [pageNameKey]: {
    explanation: "{possible} <b>{machine}</b> {status}",
    possible: "Possibile",
    machine: "Macchina",
    status: "Stato",
    disconnectedLabel: "Disconnesso",
    disconnectedDescription:
      "La connessione alla macchina (e.g. OPC UA server) non è stata stabilita.",
    connectedLabel: "Connesso",
    connectedDescription:
      "Connessione al server della macchina (e.g. OPC UA server) è stata stabilita.",
  },
};

export const questionMarkPopoverEs = {
  [pageNameKey]: {
    explanation: "{possible} <b>{machine}</b> {status}",
    possible: "Posible",
    machine: "máquina",
    status: "Estado",
    disconnectedLabel: "Desconectado",
    disconnectedDescription:
      "No se ha establecido la conexión con la máquina (p. ej. OPC UA server).",
    connectedLabel: "Conectado",
    connectedDescription:
      "Se ha establecido la conexión con la máquina (p. ej., servidor OPC UA).",
  },
};

export const questionMarkPopoverNl = {
  [pageNameKey]: {
    connectedDescription:
      "Er is verbinding met de machine (bijv. OPC UA-server) tot stand gebracht.",
    connectedLabel: "Verbonden",
    disconnectedDescription:
      "Er is geen verbinding met de machine (bijv. OPC UA-server) tot stand gebracht.",
    disconnectedLabel: "Verbinding verbroken",
    explanation: "{possible} <b>{machine}</b> {status}",
    machine: "Machine",
    possible: "Mogelijk",
    status: "Status",
  },
};

export const questionMarkPopoverTr = {
  [pageNameKey]: {
    connectedDescription: "Makineye bağlantı (örn. OPC UA sunucusu) kuruldu.",
    connectedLabel: "Bağlı",
    disconnectedDescription:
      "Makineye bağlantı (örn. OPC UA sunucusu) kurulmadı.",
    disconnectedLabel: "Bağlantı kesildi",
    explanation: "{possible} <b>{machine}</b> {status}",
    machine: "Makine",
    possible: "Olası",
    status: "Durum",
  },
};
